import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Col, message, Row, Typography} from 'antd';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';
import useDefaultRequest from '../../hooks/useDefaultRequest';
import Form from '../../components/data_entry/form/Form';
import InputNumberFormField from '../../components/data_entry/form/InputNumberFormField';
import Button from '../../components/data_entry/Button';
import Loading from '../../components/admin/Loading';
import {BuildFieldErrorsDict} from '../../utils/utils';
import InputFormField from "../../components/data_entry/form/InputFormField";
import {MASK_TYPES_INPUT} from "../../constants/constants";

const FORM_NAMES = {
    PRICE: 'price',
};

export default function AdminShippingRateForm() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const {id} = useParams();

    const {data, isLoading: fetching} = useDefaultRequest({
        url: formatPath(ENDPOINTS.ECOMMERCE_SHIPPING_RATE_DETAIL, {id}),
        makeRequest: !!id,
        redirectRoute: ROUTES.ADMIN_ECOMMERCE_SHIPPING_LIST
    });

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                [FORM_NAMES.PRICE]: Number(data[FORM_NAMES.PRICE]),
            });
        }
    }, [data, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await api.patch(formatPath(ENDPOINTS.ECOMMERCE_SHIPPING_RATE_DETAIL, {id}), {
                [FORM_NAMES.PRICE]: values[FORM_NAMES.PRICE],
            });
            message.success('Frete atualizado com sucesso');
            navigate(ROUTES.ADMIN_ECOMMERCE_SHIPPING_LIST);
        } catch (error) {
            BuildFieldErrorsDict(error, form.setFields);
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return <Loading />;
    }

    return (
        <Row>
            <Col xs={24}>
                <Typography.Title style={{marginTop: 0}} level={2}>
                    Editar Frete {data ? `- ${data.state_name} (${data.state_code})` : ''}
                </Typography.Title>
            </Col>
            <Col xs={24} lg={24}>
                <Form
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <InputFormField
                                maskType={MASK_TYPES_INPUT.MONEY}
                                prefix="R$"
                                form={{
                                    label: 'Preço do Frete',
                                    name: FORM_NAMES.PRICE,
                                    rules: [{
                                        required: true,
                                        message: 'Informe o preço'
                                    }]
                                }}
                            />
                        </Col>
                        <Col xs={24} style={{textAlign: 'right', marginTop: 24}}>
                            <Button
                                type="default"
                                style={{marginRight: 8}}
                                onClick={() => navigate(ROUTES.ADMIN_ECOMMERCE_SHIPPING_LIST)}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={form.submit}
                                loading={loading}
                            >
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );
}
